import { useEffect } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import classes from './login-redirect.module.scss'
import CryptoJS from 'crypto-js';
import { HOST_URL, AUTHORIZATION_URL, AUTHORIZATION_CLIENT_ID, MARKETPLACE_OAUTH2_STATE, MARKETPLACE_CODE_CHALLENGE, REDIRECT_URL} from '@marketplace/common'

export const LoginRedirect = () => {

    useEffect(() => {
        window.location.replace(getAuthRedirectURL());
    });

    return(
        <div className={classes.spinner_wrapper}>
            <ProgressSpinner />
        </div>
    )
}

export const getRandomString = (length = 25): any =>
  CryptoJS.lib.WordArray.random(length);

export const getAuthRedirectURL = (): string => {
  let code_challenge = localStorage.getItem(MARKETPLACE_CODE_CHALLENGE);
  let state = localStorage.getItem(MARKETPLACE_OAUTH2_STATE);

  if (!code_challenge || !state) {
    localStorage.setItem(MARKETPLACE_CODE_CHALLENGE, getRandomString());
    localStorage.setItem(MARKETPLACE_OAUTH2_STATE, getRandomString());
  }

  code_challenge = localStorage.getItem(MARKETPLACE_CODE_CHALLENGE);
  state = localStorage.getItem(MARKETPLACE_OAUTH2_STATE);

  return `${AUTHORIZATION_URL}/auth-code?client_id=${AUTHORIZATION_CLIENT_ID}&redirect_uri=${HOST_URL}/${REDIRECT_URL}&response_type=code&scope=openid&code_challenge=${code_challenge}&code_challenge_method=plain&state=${state}`;
};